var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26_1520",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 0H0V22H22V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26_1520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2927 4.29688H17.5669L12.5984 9.97563L18.4435 17.7031H13.8668L10.2822 13.0164L6.18054 17.7031H3.90494L9.21929 11.6291L3.61206 4.29688H8.30491L11.5451 8.58069L15.2927 4.29688ZM14.4945 16.3419H15.7547L7.62016 5.58663H6.26785L14.4945 16.3419Z",
    fill: "#FC5719"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.2fbed02bd349af00cb9fb7d6b9fec5ed.svg";
export { ForwardRef as ReactComponent };